import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalComponent } from './Modal.component';

export const ModalModuleExports = [ModalComponent];

@NgModule({
    imports: [CommonModule],
    declarations: [...ModalModuleExports],
    exports: [...ModalModuleExports],
    providers: []
})
export class ModalModule {}
